import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2928d304")
const _hoisted_1 = ["onClick"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["items-center", ['bal-tab-container', _ctx.containerClasses]])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass([['bal-tab', _ctx.stateClasses(tab)], "flex-1 text-center"]),
          onClick: ($event: any) => (_ctx.onClick(tab))
        }, _toDisplayString(tab.label), 11, _hoisted_1))
      }), 128))
    ], 2)
  ]))
}